// Module
var code = "<div id=\"alerts\"><div class=\"alert-item theme-{( alert.theme )}\" ng-repeat=\"alert in alerts track by $index\" ng-class=\"alert.cssClass\" ng-click=\"removeAlert(alert)\"><p class=\"title\">{( alert.title )}</p><p class=\"message\" ng-repeat=\"msg in alert.messages track by $index\">{( msg )}</p></div></div>";
// Exports
module.exports = code;